import { render, staticRenderFns } from "./CadastrarFuncionariosV2.vue?vue&type=template&id=139e1652"
import script from "./CadastrarFuncionariosV2.vue?vue&type=script&lang=js"
export * from "./CadastrarFuncionariosV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports